export default __webpack_public_path__ + "static/media/Indicator.08475b1c.svg";